
import { computed, defineComponent, PropType } from "vue";
import CategorySaleForm from "@/Components/Reports/CategorySaleForm.vue";
import Category from "@/types/Category";
import Card from "@/Components/General/Card.vue";
import { BarChart } from "vue-chart-3";
import { Chart, ChartData, BarController, CategoryScale, LinearScale, ArcElement, BarElement, ChartOptions, Tooltip, Title } from "chart.js";
import dayjs from "dayjs";
import AppLayoutVue from "@/Layouts/AppLayout.vue";
import StatisticsNav from "@/Components/Reports/StatisticsNav.vue";

Chart.register(BarController, CategoryScale, LinearScale, BarElement, Tooltip, Title);

interface SaleData {
  month: number;
  count: number;
}

export default defineComponent({
  layout: AppLayoutVue,
  props: {
    categories: {
      type: Array as PropType<Category[]>,
      required: true,
    },
    selectedCategories: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    excludeWeborders: {
      type: Boolean,
      default: () => false,
    },
    data: {
      type: Array as PropType<SaleData[]>,
      required: true,
    },
    dateFrom: {
      type: String,
      required: true,
    },
    dateTo: {
      type: String,
      required: true,
    }
  },
  setup(props) {
    const chartData = computed((): ChartData<"bar"> => {
      return {
        labels: ["Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
        datasets: [
          {
            label: "Antall ordre",
            data: props.data?.map((data) => data.count) ?? [],
            backgroundColor: "hsl(197, 57%, 31%)"
          }
        ],
      }
    });

    const chartOptions: ChartOptions = {
      animation: {
        duration: 750,
      },
      plugins: {
        title: {
          display: true,
          text: "Ordre per ukedag",
        }
      },
      scales: {
        y: {
          beginAtZero: true,
        }
      },
      locale: "nb-NO",
      maintainAspectRatio: false,
    }
    return {
      chartData,
      chartOptions,
    };
  },
  components: { CategorySaleForm, Card, BarChart, StatisticsNav }
});
